import { registerSW } from 'virtual:pwa-register';
import type { RootStore, ServiceStore } from '@intrasync/stores';

export function permissionRequest() {
  return new Promise(function (resolve, reject) {
    const permissionResult = Notification.requestPermission(function (result) {
      resolve(result);
    });

    if (permissionResult) {
      permissionResult.then(resolve, reject);
    }
  })
    .then(function (permissionResult) {
      if (permissionResult !== 'granted') {
        // Permission not granted
      }
    })
    .catch(() => {
      // Permission request error
    });
}

export const pwaRegistration = (rootStore: RootStore) => {
  try {
    const updateSW = registerSW({
      onNeedRefresh() {
        if (rootStore?.viewStore) {
          rootStore.viewStore?.setAppUpdateFound(true);
        }
      },
      onOfflineReady() {
        // Offline ready
      },
      onRegisteredSW(swPath: string, registration: ServiceWorkerRegistration) {
        if (rootStore?.viewStore) {
          rootStore.viewStore?.setSwRegistration(registration);
        }
      },
      onRegisterError(err: unknown) {
        // Handle InvalidStateError gracefully in development
        if (err instanceof Error && err.name === 'InvalidStateError') {
          return;
        }
        if (rootStore?.logStore) {
          const logStore = rootStore.logStore as ServiceStore;
          logStore
            .create({
              message: 'Error Creating Service Worker',
              level: 'error',
              payload: err,
            })
            .catch(() => {
              // Log creation error
            });
        }
      },
    });
    if (rootStore?.viewStore && updateSW) {
      rootStore.viewStore.setSWUpdater(updateSW);
    }
    return 'Successfully Registered';
  } catch {
    // Service worker registration error
  }
};
